import {  fetchImage, Repository } from "./repository";
const resource = "Technician";
const TechnicianRepo = {
    getTechnicianInfo,
    getTechnicianImage
};
function getTechnicianInfo(payLoad) {
    return Repository().get(`${resource}/getTechnicianInfo?${payLoad}`);
}
function  getTechnicianImage(payLoad) {
    return fetchImage(`${resource}/getTechnicianImage?${payLoad}`)
}
export default TechnicianRepo;